export default "__VITE_ASSET__EKp7C41$__"